import { observer } from 'mobx-react';
import { useResolvedPath } from 'react-router-dom';
import { Loader } from '@servicetitan/web-components';
import { CenteredSpinner } from '@servicetitan/marketing-ui';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { CenteredError } from '../../../../common/components/centered-error/centered-error';
import { FleetStore } from '../../store/fleet.store';

export const FleetPage = provide({ singletons: [FleetStore] })(
    observer(() => {
        const [{ src }] = useDependencies(FleetStore);

        const basename = useResolvedPath({
            pathname: '',
        }).pathname;

        return (
            <Loader
                src={src}
                basename={basename}
                errorFallback={<CenteredError />}
                loadingFallback={<CenteredSpinner />}
            />
        );
    }),
);
